import React from "react";
const res = {
  "monthNamesS": ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
  "monthNames": ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
  "monthNamesL": ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
  "dayNames": ['Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт', 'Ндл'],
  "dayNamesL": ['Понеділок', 'Вівторок', 'Середа', 'Четвер', "П'ятниця", 'Субота', 'Неділя'],
  "yearsS": "Р",
  "monthS": "Міс",
  "daysS": "Д",
  "hoursS": "Год",
  "minutesS": "Хв",
  "oClock": "година",
  "unknown": "невідомий час",
  "bc": "до н. е.",
  "bn": "млрд.",
  "mn": "млн.",
  "thousands": "тис.",
  "th": "s",
  "cen": ". ст.",
  "mil": ". mil.",
  "bil": ". bil.",
  "tril": ". tril.",
  "mnCen": ". еон.",
  "bnCen": ". bnCen.",
  "trilCen": ". trilCn.",
  "bilCen": ". bilCen.",
  "born": "народився",
  "earliest": "найраніше",
  "start": "Старт",
  "founded": "Фундація",
  "discovered": "виявлено",
  "published": "Публікація",
  "firstDescribed": "Перший опис",
  "baptized": "охрещений",
  "premiered": "Прем'єра",
  "firstMentioned": "Перша згадка",
  "activeYears": "Роки діяльності",
  "opened": "відкривається",
  "inaugurated": "Присяга на посаду",
  "activeSince": "активний з того часу, як",
  "production": "виробництво",
  "moment": "час",
  "maidenFlight": "перший політ",
  "died": "померла.",
  "latest": "найпізніше",
  "end": "кінець",
  "closed1": "Виведення з експлуатації",
  "dissolved": "розпущено",
  "missingSince": "пропав безвісти з тих пір, як",
  "activeUntil": "активний до тих пір, поки",
  "discontinued": "набір",
  "closed": "закрито",
  "landing": "Посадка",
  "reentry": "Повторний вхід"
};
export default res;